(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["animations"] && !Shopify.designMode) return;
  try {
    (function () {
    function revealAll() {
      document.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    function scan() {
      document.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
        if (el.getBoundingClientRect().top >= window.innerHeight) el.classList.add('is-pending');
        observer.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }

    document.addEventListener('shopify:section:load', scan);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["coming-soon-signup"] && !Shopify.designMode) return;
  try {
    (function () {
    function reveal() {
      var forms = document.querySelectorAll('[data-soon-form]');
      forms.forEach(function (form) {
        var tags = form.querySelector('[data-soon-tags]');
        var choice = form.querySelector('[data-soon-newsletter]');
        var label = form.querySelector('[data-soon-newsletter-label]');
        if (!tags || !choice || !label || form.dataset.soonReady) return;
        form.dataset.soonReady = 'true';
        var launchTags = tags.value;
        function updateTags() {
          tags.value = launchTags + (choice.checked ? ',newsletter' : '');
        }
        label.hidden = false;
        choice.addEventListener('change', updateTags);
        form.addEventListener('submit', updateTags);
        updateTags();
      });
      var target = location.hash ? document.getElementById(location.hash.slice(1)) : null;
      if (!target && forms.length === 1) target = forms[0];
      if (!target || !target.hasAttribute('data-soon-form')) return;
      var success = target.querySelector('[data-soon-success]');
      var error = target.querySelector('[data-soon-error]');
      if (success) {
        success.hidden = false;
        var row = target.querySelector('[data-soon-fields]');
        if (row) row.hidden = true;
      } else if (error) {
        error.hidden = false;
      }
    }
    window.addEventListener('pageshow', reveal);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reveal);
    } else {
      reveal();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cookie-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    var errorMessage = document.getElementById('cookie-settings-error');
    if (!errorMessage) return;
    var pending = false;

    // Keep the visitor's storefront/password session and locale. Shopify's
    // absolute banner URL can otherwise switch to a different shop domain.
    var policyUrl = new URL(errorMessage.dataset.policyUrl, window.location.href);
    var policyPath = policyUrl.pathname + policyUrl.search + policyUrl.hash;
    function updatePrivacyLink() {
      var link = document.getElementById('shopify-pc__banner__body-policy-link');
      if (!link) return;
      link.setAttribute('href', policyPath);
      link.removeAttribute('target');
    }
    updatePrivacyLink();
    // The native banner is inserted asynchronously and can be recreated.
    new MutationObserver(updatePrivacyLink).observe(document.body, { childList: true, subtree: true });

    // Reported on iPhone: tapping a category in Shopify's preferences did not
    // tick it. If a tap on a category leaves its checkbox unchanged, toggle it
    // here and tell Shopify through the same change event a real toggle fires.
    var tappedBefore = new WeakMap();
    document.addEventListener('pointerdown', function (event) {
      var label = event.target.closest('label[for^="shopify-pc__prefs__"]');
      var input = label && document.getElementById(label.htmlFor);
      if (input) tappedBefore.set(input, input.checked);
    }, true);
    document.addEventListener('click', function (event) {
      var label = event.target.closest('label[for^="shopify-pc__prefs__"]');
      var input = label && document.getElementById(label.htmlFor);
      // The label's own activation fires a second click on the input; only the tap counts.
      if (!input || event.target === input || input.disabled || input.getAttribute('aria-readonly') === 'true') return;
      var before = tappedBefore.has(input) ? tappedBefore.get(input) : input.checked;
      tappedBefore.delete(input);
      setTimeout(function () {
        if (input.checked !== before) return;
        input.checked = !before;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }, 0);
    }, true);

    document.addEventListener('click', async function (event) {
      var trigger = event.target.closest('[data-cookie-settings-open]');
      if (!trigger) return;
      event.preventDefault();
      if (pending) return;
      errorMessage.hidden = true;
      pending = true;
      trigger.setAttribute('aria-busy', 'true');
      try {
        if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') {
          throw new Error('Shopify cookie preferences are not available');
        }
        await window.privacyBanner.showPreferences();
        // Shopify can resolve without displaying a dialog on a password page.
        if (!document.getElementById('shopify-pc__prefs__dialog')) {
          throw new Error('Shopify cookie preferences did not open');
        }
      } catch (error) {
        trigger.insertAdjacentElement('afterend', errorMessage);
        errorMessage.hidden = false;
      } finally {
        pending = false;
        trigger.removeAttribute('aria-busy');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["country-routing"] && !Shopify.designMode) return;
  try {
    (async function () {
    const form = document.getElementById('country-routing');
    if (!form) return;
    const settings = form.querySelector('[data-countries]').dataset;
    const supported = settings.countries.split(',');
    const passwordPage = settings.passwordPage === 'true';
    const current = form.elements.country_code.value;
    const key = 'vamoya-country-choice';
    const languageKey = 'vamoya-language-choice';
    const languages = (settings.languages || '').split(',').filter(Boolean);
    const currentLanguage = settings.language;
    const primaryLanguage = settings.primaryLanguage;
    const url = new URL(window.location.href);
    let manuallyChanged = false;

    function preferredLanguage() {
      // A /fr/… URL is an explicit choice (shared link, language switcher, search result).
      if (currentLanguage !== primaryLanguage) return currentLanguage;
      try {
        const saved = localStorage.getItem(languageKey);
        if (languages.includes(saved)) return saved;
      } catch (_) { /* Without storage the browser language decides on every visit. */ }
      if (/bot|crawl|spider|slurp|lighthouse/i.test(navigator.userAgent || '')) return currentLanguage;
      for (const tag of navigator.languages || [navigator.language]) {
        const base = String(tag).toLowerCase().split('-')[0];
        const match = languages.find(function (code) { return code.toLowerCase().split('-')[0] === base; });
        if (match) return match;
      }
      return currentLanguage;
    }
    const language = preferredLanguage();

    function localizedPath(target) {
      const root = window.Shopify.routes.root;
      const path = window.location.pathname.slice(root.length - 1);
      return (target === primaryLanguage ? '' : '/' + target.toLowerCase()) + path;
    }

    function switchLanguage() {
      if (language === currentLanguage) return false;
      if (passwordPage) {
        window.location.replace(localizedPath(language) + window.location.search + window.location.hash);
        return true;
      }
      form.elements.locale_code.value = language;
      let returnTo = form.querySelector('[name="return_to"]');
      if (!returnTo) {
        returnTo = document.createElement('input');
        returnTo.type = 'hidden';
        returnTo.name = 'return_to';
        form.append(returnTo);
      }
      returnTo.value = window.location.pathname + window.location.search + window.location.hash;
      form.dataset.routing = 'language';
      form.submit();
      return true;
    }

    function remember(country, source) {
      try {
        localStorage.setItem(key, JSON.stringify({
          country, source, expires: Date.now() + (source === 'manual' ? 2592000000 : 600000)
        }));
      } catch (_) { /* Country selection still works when browser storage is unavailable. */ }
    }

    function savedChoice() {
      try {
        const value = JSON.parse(localStorage.getItem(key));
        if (value && value.expires > Date.now() && supported.includes(value.country)) return value;
      } catch (_) { /* Ignore unavailable storage and expired or invalid preferences. */ }
      return null;
    }

    function returnPath(country, source) {
      const target = new URL(window.location.href);
      target.searchParams.delete('country');
      target.searchParams.set('v_country', country);
      target.searchParams.set('v_country_source', source);
      const path = passwordPage ? localizedPath(language) : target.pathname;
      return path + target.search + target.hash;
    }

    function prepareSelection(targetForm, country, source) {
      let returnTo = targetForm.querySelector('[name="return_to"]');
      if (!returnTo) {
        returnTo = document.createElement('input');
        returnTo.type = 'hidden';
        returnTo.name = 'return_to';
        targetForm.append(returnTo);
      }
      returnTo.value = returnPath(country, source);
      remember(country, source);
    }

    function selectCountry(country, source) {
      const host = window.location.hostname.replace(/^www\./, '');
      const targetHost = country === 'CH' ? 'vamoya.ch' : 'vamoya.de';
      const wrongDomain = ['vamoya.ch', 'vamoya.de'].includes(host) && host !== targetHost;
      remember(country, source);
      if (passwordPage) {
        form.dataset.routing = wrongDomain ? 'redirecting' : 'matched';
        if (wrongDomain) window.location.replace('https://' + targetHost + returnPath(country, source));
        else switchLanguage();
        return;
      }
      if (country === current && !wrongDomain) {
        if (!switchLanguage()) form.dataset.routing = 'matched';
        return;
      }
      form.elements.country_code.value = country;
      form.elements.locale_code.value = language;
      prepareSelection(form, country, source);
      form.dataset.routing = 'redirecting';
      form.submit();
    }

    // The header language switcher submits with <button name="locale_code">.
    document.addEventListener('click', function (event) {
      const button = event.target.closest && event.target.closest('button[name="locale_code"]');
      if (!button || !languages.includes(button.value)) return;
      try { localStorage.setItem(languageKey, button.value); } catch (_) { /* The switcher still works. */ }
    }, true);

    document.addEventListener('change', function (event) {
      const select = event.target;
      if (select.name === 'locale_code' && select.form !== form && languages.includes(select.value)) {
        try { localStorage.setItem(languageKey, select.value); } catch (_) { /* The switcher still works. */ }
        return;
      }
      if (select.name !== 'country_code' || !select.form || select.form === form) return;
      if (!supported.includes(select.value)) return;
      manuallyChanged = true;
      prepareSelection(select.form, select.value, 'manual');
    }, true);

    const incoming = url.searchParams.get('v_country');
    const incomingSource = url.searchParams.get('v_country_source');
    const explicit = url.searchParams.get('country');
    if (supported.includes(incoming) && ['manual', 'auto'].includes(incomingSource)) {
      remember(incoming, incomingSource);
      url.searchParams.delete('v_country');
      url.searchParams.delete('v_country_source');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      form.dataset.routing = incoming === current ? 'selected' : 'selection-failed';
      switchLanguage();
      return;
    }
    if (supported.includes(explicit)) {
      selectCountry(explicit, 'manual');
      return;
    }

    try {
      const choice = savedChoice();
      let country = choice && choice.country;
      const source = choice ? choice.source : 'auto';
      if (!country) {
        let response = await fetch(window.Shopify.routes.root + 'browsing_context_suggestions.json?country[enabled]=true', {
          signal: AbortSignal.timeout(5000)
        });
        if (response.status === 401) {
          response = await fetch('https://vamoya-comming-soon.vercel.app/api/country', {
            credentials: 'omit', referrerPolicy: 'no-referrer', signal: AbortSignal.timeout(5000)
          });
        }
        if (!response.ok) { form.dataset.routing = 'detection-unavailable'; switchLanguage(); return; }
        const data = await response.json();
        const detected = data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (!/^[A-Z]{2}$/.test(detected)) { form.dataset.routing = 'unknown-country'; switchLanguage(); return; }
        country = supported.includes(detected) ? detected : 'DE';
        form.dataset.detectedCountry = detected;
      }
      if (manuallyChanged || !supported.includes(country)) return;
      selectCountry(country, source);
    } catch (_) {
      form.dataset.routing = 'detection-unavailable';
      if (!manuallyChanged) switchLanguage();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["focus-trap"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.VamoyaFocus) return;

    var FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function visible(el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length) && !el.hasAttribute('hidden');
    }

    function focusables(root) {
      return Array.prototype.slice.call(root.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return visible(el) && el.tabIndex >= 0 && !el.matches(':disabled') && !el.closest('[inert]');
      });
    }

    function trap(event, root) {
      if (event.key !== 'Tab' || !root) return;
      var items = focusables(root);
      if (!items.length) {
        event.preventDefault();
        if (root.focus) root.focus();
        return;
      }
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;
      var outside = active === root || !root.contains(active);
      if (event.shiftKey && (active === first || outside)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (active === last || outside)) {
        event.preventDefault();
        first.focus();
      }
    }

    // Which input device drove the last interaction. Overlays must hand focus
    // back to the control that opened them — screen readers depend on it — but
    // a programmatic .focus() makes Safari paint the :focus-visible ring even
    // after a tap, which reads as a button stuck in a highlighted state. So we
    // keep the focus and drop only the ring when the user is not on a keyboard.
    var modality = 'pointer';
    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key === 'Tab' || event.key === 'Escape' || event.key === 'Enter' || event.key === ' ') {
          modality = 'keyboard';
        }
      },
      true
    );
    document.addEventListener(
      'pointerdown',
      function () {
        modality = 'pointer';
      },
      true
    );

    function focusQuietly(el) {
      if (!el || typeof el.focus !== 'function') return;
      if (modality === 'keyboard') {
        // Clear a leftover flag: focus may never have blurred since the last
        // tap, and a keyboard user must always get the ring back.
        el.classList.remove('focus-no-ring');
        el.focus();
        return;
      }
      el.classList.add('focus-no-ring');
      el.focus();
      el.addEventListener(
        'blur',
        function () {
          el.classList.remove('focus-no-ring');
        },
        { once: true }
      );
    }

    window.VamoyaFocus = {
      focusables: focusables,
      trap: trap,
      modality: function () {
        return modality;
      },
      focusQuietly: focusQuietly,
      focusFirst: function (root) {
        var items = focusables(root);
        if (items.length) items[0].focus();
        else if (root && root.focus) root.focus();
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-switcher"] && !Shopify.designMode) return;
  try {
    (function () {
    function closeAll(except) {
      document.querySelectorAll('[data-lang-menu][open]').forEach(function (menu) {
        if (menu !== except) menu.removeAttribute('open');
      });
    }
    document.addEventListener('click', function (event) {
      closeAll(event.target.closest('[data-lang-menu]'));
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var open = document.querySelector('[data-lang-menu][open]');
      if (!open) return;
      open.removeAttribute('open');
      open.querySelector('summary').focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function initGallery(gallery) {
      if (!gallery || gallery.dataset.zoomReady === 'true') return;
      gallery.dataset.zoomReady = 'true';

      var dialog = gallery.querySelector('[data-gallery-zoom]');
      var img = gallery.querySelector('[data-gallery-zoom-img]');
      if (!dialog || !img) return;

      gallery.addEventListener('click', function (event) {
        var openBtn = event.target.closest('[data-gallery-zoom-open]');
        if (openBtn && gallery.contains(openBtn)) {
          img.src = openBtn.getAttribute('data-zoom-src');
          img.alt = openBtn.getAttribute('data-zoom-alt') || '';
          var zw = openBtn.getAttribute('data-zoom-w');
          var zh = openBtn.getAttribute('data-zoom-h');
          if (zw && zh) {
            img.setAttribute('width', zw);
            img.setAttribute('height', zh);
          }
          dialog.showModal();
          return;
        }
        if (event.target.closest('[data-gallery-zoom-close]') || event.target === dialog) {
          dialog.close();
        }
      });
    }

    function run() {
      document.querySelectorAll('[data-gallery]').forEach(initGallery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-stepper"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var minus = event.target.closest('[data-qty-minus]');
    var plus = event.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var qty = (minus || plus).closest('[data-qty]');
    if (!qty) return;
    var input = qty.querySelector('.qty__input');
    if (!input) return;
    var value = parseInt(input.value, 10) || 0;
    var min = parseInt(input.min, 10) || 0;
    input.value = minus ? Math.max(min, value - 1) : value + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  } catch(e) { console.error(e); }
})();

})();
